import { Store } from 'src/store/index';

const getBasketUrl = (store: Store) => store.app.basketUrl;

export default getBasketUrl;
